import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FlagFilled, MessageOutlined } from '@ant-design/icons'
import { List, Card, Tag, Row, Col } from 'antd'
import { toStringToUnderscore, standardDate } from '../flag-management.tools'
import { selectJob, updateJobStatistics } from '@actions/jobList'
import ChatNotifications from './chat-notification/chat-notification.component'
import Moment from 'react-moment'
import { getTimeZoneDifferentNumber, formatHourWithUtc } from '../../../utils/dates'
import Icons from '@commonComponents/Icons'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import * as moment from 'moment'
import { useHookstate } from '@hookstate/core'
import { NotificationsGlobalState } from '../../../refactory/kernel/infrastructure/notifications/notifications-global-state'

const CANCELLED = 'CANCELLED'

const Flag = (props) => {
  const { jobId } = useParams()
  const location = useLocation()
  const history = useHistory()
  const { messages } = useHookstate(NotificationsGlobalState)
  const { dispatch, state, selectedJobAlert } = props
  const { selectedJob, jobs } = state
  const { t } = useTranslation()

  const setJob = async (job, index) => {
    const { currentUser } = props
    if (currentUser && currentUser.user.id !== '') {
      const {
        user: { id: userId }
      } = currentUser

      if (job.lastFlag && userId === job.lastFlag.userId) {
        if (!job.lastFlag.viewedAt) {
          job.lastFlag.viewedAt = moment()
        }
        updateJobStatistics(userId, jobs, dispatch)
      }
    }
    selectJob(job, index, dispatch)
    const filteredMessages = messages.get({ noproxy: true }).filter((message) => message.jobId !== job.uuid)
    messages.set(filteredMessages)
  }

  const showAlertDifferentsTimeZone = (timeZoneNumber) => {
    if (timeZoneNumber !== null) {
      return (
        <label className='time-zone-alert'>
          {' '}
          UTC{timeZoneNumber !== 0 ? timeZoneNumber : ''} <Icons iconName='Warning' style={{ marginLeft: '3px' }} />
        </label>
      )
    }
    return null
  }

  const selectJobAlert = (job, index) => {
    if (
      !location.pathname.includes('items') &&
      !location.pathname.includes('resources') &&
      !location.pathname.includes('cancel') &&
      !location.pathname.includes('issue') &&
      !location.pathname.includes('change-store') &&
      !location.pathname.includes('reschedule') &&
      !location.pathname.includes('invoices')
    ) {
      history.push(`/alert-management/orders/${job.id}`)
    }
    setJob(job, index)
  }

  useEffect(() => {
    if (jobId && selectedJobAlert) {
      setJob(selectedJobAlert, selectedJobAlert.index)
    }
  }, [selectedJobAlert])

  return (
    <List
      className='jobs-list'
      dataSource={jobs}
      renderItem={(job, index) => {
        const lastFlag =
          job.lastFlag && job.lastFlag.category ? (
            <div className='last-flag'>
              <Row>
                <Col span='4'>
                  <FlagFilled />
                </Col>
                <Col span='20'>
                  <span className='flag-name'>{t(`flags.${toStringToUnderscore(job.lastFlag.category.name)}`)}</span>
                </Col>
              </Row>
            </div>
          ) : null
        const chat = job.chat ? (
          <div className='chat'>
            <MessageOutlined />
          </div>
        ) : null
        const footer =
          job.lastFlag || job.chat ? (
            <div className='footer'>
              <Row justify='space-between' className=''>
                <Col xs={24} md={12} lg={14} xl={16} xxl={18}>
                  {lastFlag}
                  {chat}
                  <ChatNotifications job={job} state={state} dispatch={dispatch} />
                </Col>
                <Col xs={24} md={12} lg={10} xl={8} xxl={6} className='priority'>
                  <Tag color='red'>{`${t('jobs.jobList.priority')} ${job.priority}`}</Tag>
                </Col>
              </Row>
            </div>
          ) : null
        const isIssue = job.issueOf ? (
          <Tag className='job-tags gold'>{t('jobs.job.info.items-view.issue-view.issue-card')}</Tag>
        ) : null
        const isCancel =
          job.status === CANCELLED ? <Tag className='job-tags red'>{t('jobs.jobCancel.cancel-card')}</Tag> : null

        const userInfo = JSON.parse(localStorage.getItem('user_info'))
        const timeZone =
          job.storeTimezone && !job.storeTimezone.includes('UTC') ? job.storeTimezone : userInfo.user.client.timeZone
        const timeZoneNumber = getTimeZoneDifferentNumber(timeZone)

        return (
          <List.Item
            className={`job-card ${selectedJob ? (job.id === selectedJob.id ? 'selected-job' : 'unselected-job') : ''}`}
          >
            <Card id='show-job-card' bordered={false} onClick={() => selectJobAlert(job, index)}>
              <div className='card-body job-card-body'>
                <div className='job-card-header'>
                  <h3>
                    <div className={`job-card-header-icon ${job.lastFlag.viewedAt ? 'viewed' : ''}`} />
                    {job.jobNumber}
                  </h3>
                  <div>
                    {isIssue}
                    {isCancel}
                  </div>
                </div>
                <dl>
                  <dt>
                    <b>{t('jobs.jobList.delivery')}:</b>
                  </dt>
                  <dd className='secondary-text'>
                    <Moment format='L'>{formatHourWithUtc(standardDate(job.storeTzSlotFrom))}</Moment>{' '}
                    <Moment format='LT'>{formatHourWithUtc(standardDate(job.storeTzSlotFrom))}</Moment>
                    {` - `}
                    <Moment format='LT'>{formatHourWithUtc(standardDate(job.storeTzSlotTo))}</Moment>
                    {showAlertDifferentsTimeZone(timeZoneNumber)}
                  </dd>
                </dl>
                <dl>
                  <dt>
                    <b>{t('jobs.jobList.origin')}:</b>
                  </dt>
                  <dd className='secondary-text'>{job.origin.name}</dd>
                </dl>
                <dl>
                  <dt>
                    <b> {t('jobs.jobList.destination')}:</b>
                  </dt>
                  <dd className='secondary-text'>{job.destination.address}</dd>
                </dl>
              </div>
            </Card>
            {footer}
          </List.Item>
        )
      }}
    />
  )
}

export default Flag
